export default __webpack_public_path__ + "static/media/interface-6.072fa596.png";